const Page404 = () => {
  return (
    <>
      <div className="text-section font-bold text-mainText">Page Not Found</div>
    </>
  );
};

export default Page404;
